module.exports = __webpack_public_path__ + "img/tweeter.2ae94c5.png";